import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import React, {useEffect} from "react";
import {getDetailData} from "../../models/transactionModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import {fetchTransactionById} from "../../store/transaction-slice";
import {fetchNotApplicableList} from "../../store/list-slice";

const TransactionDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.transaction);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.transaction);

    const list = useSelector(state => state.list);
    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchTransactionById({...userRole, id: params.transactionId}));
    }, [dispatch, params.transactionId, userRole]);

    useEffect(() => {
        dispatch(fetchNotApplicableList())
    }, [dispatch]);

    const item = items.find(item => item.id === params.transactionId);
    const detailData = getDetailData({item, list});
    return (
        <>
            <SubHeader title="Transaction Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>}
            </div>
        </>
    )
}

export default TransactionDetail;